<template>
    <div>
        <b-modal id="campaign-edit" title="Edit campaign" :hide-footer="hideFooter">
            <form>
                <div class="form-group">
                    <label for="#cmpName">Campaign Name:</label>
                    <input class="form-control" type="text" placeholder="Ex: Soccer" required="required" v-model="campaign.name">
                </div>
                <div class="form-group">
                    <label for="#cmpCode">Campaign code:</label>
                    <input class="form-control" type="text" placeholder="Ex: 2" required="required" v-model="campaign.code">
                </div>
                <div class="form-group">
                    <label for="#bkmDescription">Campaign Description:</label>
                    <textarea class="form-control" id="cmpDescription" v-model="campaign.description"></textarea>
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-secondary form-control" @click.prevent="updateCampaign">Update</button>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import { Bus } from '@/main'
export default {
  data () {
    return {
      hideFooter: true,
      campaign: ''
    }
  },
  methods: {
    updateCampaign () {
      if (this.campaign.description && this.campaign.code && this.campaign.name) {
        this.$http.patch(`${this.$api_url}/campaign/edit/` + this.campaign._id, { code: this.campaign.code, description: this.campaign.description, name: this.campaign.name }).then((success, error) => {
          if (success) {
            Bus.$emit('campaignUpdated', success.data)
            this.$bvModal.hide('campaign-edit')
          }
          if (error) {
            this.$bvModal.hide('campaign-edit')
            alert('Something wrong just happened!')
          }
        })
      }
    }
  },
  created () {
    Bus.$on('editCampaign', (campaignData) => {
      this.campaign = campaignData
    })
  },
  beforeDestroy () {
    Bus.$off('editCampaign')
  }
}
</script>
<style scoped>
</style>
